import { Card, Select, Carousel } from "antd";
import { FiSearch, FiMapPin, FiPhone, FiAlertCircle } from "react-icons/fi";
import { Oval } from "react-loader-spinner";

// ------------------- css
import "./style.css";

import { FiX } from "react-icons/fi";
import { useEffect, useState } from "react";
import axios from "axios";
import { api } from "../../api/url";
import { Link, useParams } from "react-router-dom";

const DoctorsPage = () => {
  const [speciality, setSpeciality] = useState();
  const [data, changeData] = useState();
  const [specialities, changeSpecialities] = useState([]);
  const [search, changeSearch] = useState("");
  const [page, changePage] = useState(0);
  const [doctors, changeDoctores] = useState([]);
  const [loading_doctors, setLoading_doctors] = useState(true);

  const [loading, setLoading] = useState(true);
  const { id } = useParams();

  const GetInfo = async () => {
    await axios({
      method: "get",
      url: api + "appointment/company/get/" + id,
    })
      .then((res) => {
        if (res?.data?.data) {
          changeData(res.data.data);
          setLoading(false);
        } else window.location.href = "/notfound";
      })
      .catch((err) => {
        console.log("err", err);
        setLoading(false);
      });
  };

  // ------------------- GetDoctors
  const GetDoctors = async () => {
    setLoading_doctors(true);
    await axios({
      url: api + "appointment/attender/search/advanced",
      method: "post",
      data: {
        pageNo: page * 10,
        pageRowsCount: 10,
        cityId: null,
        searchKey: search,
        specialtyIds: speciality ? [speciality] : [],
        companyId: id,
        orderBy: 1,
        currentDateTime: new Date(),
      },
    })
      .then((res) => {
        if (res.data.httpStatus !== 500) {
          if (page > 0) changeDoctores([...doctors, ...res.data.data]);
          else changeDoctores(res.data.data);

          setLoading_doctors(false);
        }
      })
      .catch((err) => {
        console.log("err", err);
        setLoading_doctors(false);
      });
  };

  // ------------------- Get Specialities
  const GetSpecialities = async () => {
    // setLoading(true);
    await axios({
      url: api + "appointment/speciality/getlist/2/" + id,
      method: "get",
    })
      .then((res) => {
        changeSpecialities(res.data.data);
      })
      .catch((err) => {
        console.log("err", err);
        // setLoading(false);
      });
  };

  useEffect(() => {
    GetInfo();
    GetSpecialities();
    GetDoctors();
  }, []);

  useEffect(() => {
    GetDoctors();
  }, [page]);

  const onSearch = () => {
    changePage(0);
    GetDoctors();
  };

  // -------------- change title
  document.title = `${data?.name} | وبسلا‍‍‍‍‍`;

  return (
    <div className="doctors-page-container">
      {loading ? (
        <div className="loading-container">
          <Oval
            visible={true}
            height="35"
            width="35"
            strokeWidth={3}
            color="#1E2B3B"
            ariaLabel="oval-loading"
            secondaryColor="#ACADAD"
            wrapperStyle={{}}
            wrapperClass=""
          />
        </div>
      ) : (
        <div class="row">
          <div class="col-lg-8 department-description-container">
            <h5>{data?.name}</h5>

            <Card className="department-description-card">
              <Carousel autoplay>
                {[1, 2, 3, 4, 5, 6, 7, 8, 9].map((item) => (
                  <img
                    src={require(`../../assets/images/shooride/${item}.jpg`)}
                    className="department-cover"
                    alt="department-cover"
                  />
                ))}
              </Carousel>

              <p className="department-description">
                درمانگاه های تخصصی، فوق تخصصی و پاراکلینک های شبانه روزی طیف
                وسیعی از خدمات تشخیصی و درمانی را برای بزرگسالان و کودکان با
                استفاده از تجربه، دانش و مهارت پزشکان مجرب و متعهد ارایه می دهد.
                در تمامی بخش ها تلاش شده تا با فراهم آوردن حداکثر امکانات رفاهی
                و با بکارگیری پرستاران و کادر درمانی دلسوز و با تجربه، ارایه
                کننده بهترین خدمات درمانی به بیماران محترم باشد.
              </p>
            </Card>

            <div className="landingpage-section1-operation doctors-searchbar ">
              <Select
                // direction="ltr"
                // suffixIcon={<FiMapPin style={{ fontSize: 20 }} />}
                style={{ width: 180, height: "100%" }}
                onChange={setSpeciality}
                value={speciality}
                placeholder="انتخاب تخصص"
                // mode="multiple"
                // maxTagCount={1}
              >
                {specialities.map((item) => (
                  <Select.Option value={item.id}>{item.name}</Select.Option>
                ))}
              </Select>

              <div className="searchbar">
                <FiSearch />
                <input
                  onChange={(e) => changeSearch(e.target.value)}
                  placeholder="جستجو در بین پزشکان…"
                />
                <button onClick={() => onSearch()}>جستجو</button>
              </div>
            </div>
            {loading_doctors ? (
              <div
                style={{ paddingTop: 100, paddingBottom: 50 }}
                className="loading-container"
              >
                <Oval
                  visible={true}
                  height="35"
                  width="35"
                  strokeWidth={3}
                  color="#1E2B3B"
                  ariaLabel="oval-loading"
                  secondaryColor="#ACADAD"
                  wrapperStyle={{}}
                  wrapperClass=""
                />
              </div>
            ) : (
              <div className="doctors-list department-doctor-list">
                <>
                  {doctors.map((item, index) => (
                    <DoctorCard key={"doctors" + index} item={item} />
                  ))}
                  <Card
                    onClick={() => changePage(page + 1)}
                    className="doctors-list-loadmore"
                  >
                    موارد بیشتر
                  </Card>
                </>
              </div>
            )}
          </div>
          {data && <SideBar branchList={data?.branchList} id={id} />}
        </div>
      )}
    </div>
  );
};

export default DoctorsPage;

const SideBar = (props) => {
  return (
    <div class="col-lg-4 sidebar">
      {props.branchList.map((item) => (
        <Card className="doctors-sidebar department-sidebar">
          <h5>اطلاعات تماس</h5>
          <div className="department-contacts">
            <div className="col-lg-5 col-6">
              <div className="department-contanctsinfo-title">
                <FiPhone className="phone-icon" />
                شماره‌تماس:
              </div>

              <div className="department-contanctsinfo-title">
                <FiMapPin />
                آدرس:
              </div>
            </div>
            <div className="col-lg-7 col-6 ">
              <div className="department-contanctsinfo-value">
                {item?.phoneList?.length > 0 ? (
                  item?.phoneList?.map((ite, index) => (
                    <>
                      {index / 2 !== 0 ? "-" : null}
                      <a>{ite.phoneNo}</a>
                    </>
                  ))
                ) : (
                  <a>-</a>
                )}
              </div>
              <a className="department-contanctsinfo-value">{item.address}</a>
            </div>
          </div>
        </Card>
      ))}
      <div className="row department-rule ">
        <div className="col-lg-12 col-12 cancel-verify-modal cancel-rules-departmentpage ">
          <FiAlertCircle />
          <a target="_blank" href={"/cancelrules/" + props.id}>
            مشاهده قوانین لغو نوبت
          </a>
        </div>
      </div>
    </div>
  );
};

const DoctorCard = ({ item }) => {
  return (
    <Card className="doctorslist-card">
      <div className="doctors-card-body">
        <div className="doctors-card-avatar">
          <img
            src={
              item.attenderGenderId === 0
                ? require("../../assets/images/woman.png")
                : require("../../assets/images/man.png")
            }
          />
        </div>
        <div className="doctors-card-about">
          <h5>{item.attenderFullName}</h5>
          <p>{item.specialtyName}</p>
        </div>
      </div>

      <div className="doctor-card-footer">
        <div className="doctor-card-address">
          {item.companyList?.map((company) => (
            <div>
              <FiMapPin />
              <span>{company.name}</span>
            </div>
          ))}
        </div>

        <button>
          <Link style={{ color: "white" }} to={"/doctors/" + item.attenderId}>
            نوبت دهی آنلاین
          </Link>
        </button>
      </div>
    </Card>
  );
};
